"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var _validate = require("@/utils/validate");
var toolUtils = _interopRequireWildcard(require("@/utils/toolUtils.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      visible: false,
      orderNo: '',
      pram: {},
      details: {},
      initloading: false
    };
  },
  computed: {
    totalAmt: function totalAmt() {
      var _ref = this.pram || {},
        goodsPrice = _ref.goodsPrice,
        freightPrice = _ref.freightPrice,
        discountPrice = _ref.discountPrice;
      return Number((Number(goodsPrice * 10000) + Number(freightPrice * 10000) - Number(discountPrice * 10000)) / 10000).toFixed(2);
    }
  },
  mounted: function mounted() {
    this.pram = {};
  },
  methods: {
    openInit: function openInit(orderNo) {
      this.orderNo = orderNo;
      this.pram = {};
      this.getOrderDetails(orderNo);
    },
    handerSubmit: (0, _validate.Debounce)(function () {
      var _this = this;
      this.$refs['pramRef'].validate(function (valid) {
        if (!valid) return;
        if (_this.totalAmt < 0) {
          _this.$message.warning('最终金额不能小于0！');
          return;
        }
        ;
        var _this$pram = _this.pram,
          orderNo = _this$pram.orderNo,
          goodsPrice = _this$pram.goodsPrice,
          freightPrice = _this$pram.freightPrice,
          discountPrice = _this$pram.discountPrice;
        _this.loading = true;
        orderListApi.updatePrice({
          orderNo: orderNo,
          goodsPrice: goodsPrice,
          freightPrice: freightPrice,
          discountPrice: discountPrice
        }).then(function (data) {
          _this.$message.success('操作成功');
          _this.loading = false;
          _this.visible = false;
          _this.$emit('doRefresh');
        }).catch(function () {
          _this.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getOrderDetails: function getOrderDetails(orderNo) {
      var _this2 = this;
      this.visible = true;
      this.initloading = true;
      this.pram = {};
      this.details = {};
      orderListApi.getOrderDetail(orderNo).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _ref2 = res.orderPay || {},
          discount = _ref2.discount,
          freight = _ref2.freight,
          totalPrice = _ref2.totalPrice;
        _this2.details = res;
        _this2.pram = {
          orderNo: _this2.orderNo,
          discountPrice: Number(discount || 0),
          freightPrice: Number(freight || 0),
          goodsPrice: Number(totalPrice),
          orderItemList: res.orderItemList || []
        };
        _this2.initloading = false;
      }).catch(function (err) {
        _this2.initloading = false;
      });
    },
    // 获取地区数据
    getCityList: function getCityList() {
      var _this3 = this;
      logistics.treeLevel3().then(function (res) {
        _this3.addresData = res;
      }).catch(function (res) {
        _this3.$message.error(res.message);
      });
    }
  }
};